// Helpers for normalizing locale and building safe path segments.
export const normalizeLocale = (display = '') => String(display).replace('_', '-').toLowerCase();

export const safeSegment = (value = '') => {
    let s = String(value || '');
    s = s.replace(/^\.+/, '');
    s = s.replace(/[^a-zA-Z0-9-_]+/g, '-');
    s = s.replace(/-+/g, '-').replace(/^-|-$/g, '');
    return encodeURIComponent(s.toLowerCase());
};

export const buildAddPropertyPath = (localeDisplay, rootPath, abov = '') => {
    const loc = normalizeLocale(localeDisplay);
    const app = safeSegment(rootPath || 'list');
    return `/${loc}/${app}/add-property/location${abov}`;
};
